export default "__VITE_ASSET__cc8fefbe__"